export enum LanguagesEnum {
  PT_BR = 'pt-BR',
  EN_US = 'en-US',
  ES_ES = 'es-ES',
}

export const LanguageTrackName: Record<LanguagesEnum, string> = {
  [LanguagesEnum.PT_BR]: 'br',
  [LanguagesEnum.EN_US]: 'us',
  [LanguagesEnum.ES_ES]: 'ar',
}

export const CurrencyTrackName: Record<LanguagesEnum, string> = {
  [LanguagesEnum.PT_BR]: 'BRL',
  [LanguagesEnum.EN_US]: 'USD',
  [LanguagesEnum.ES_ES]: 'ARS',
}
